import type { ComponentPropsWithoutRef } from "react";
import { useId, useState } from "react";
import { useTranslation } from "react-i18next";

import { Input, SearchIcon } from "~/ui";

interface SearchInputProps extends ComponentPropsWithoutRef<"input"> {
  defaultValue?: string;
  onValueChange: (value: string) => void;
}

export const SearchInput = ({
  defaultValue = "",
  onValueChange,
  ...props
}: SearchInputProps) => {
  const id = useId();
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue);
  return (
    <Input
      id={id}
      aria-label={t("patients.search")}
      rightIcon={
        <SearchIcon
          aria-hidden={true}
          className="h-4 w-4 text-neutral-variant-50 dark:text-neutral-variant-95"
        />
      }
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
        onValueChange(e.target.value);
      }}
      {...props}
    />
  );
};
